import { RequestPaymentLimitedUseTokenMutationVariables } from "../../../generatedQueries";
import {
  Event,
  ConstructorArgs as EventConstructorArgs,
} from "../../core/Event";
import { EventCategories } from "../../event-categories";
import { EventSubCategories } from "../../event-sub-categories";

export type Data = {
  mutationVariables: RequestPaymentLimitedUseTokenMutationVariables;
};

export type ConstructorArgs = Data & Partial<EventConstructorArgs>;

class RequestPaymentLimitedUseTokenRequest extends Event<Data> {
  public constructor(args: ConstructorArgs) {
    const { mutationVariables, ...baseArgs } = args;

    super({
      ...baseArgs,
      category: EventCategories.UI,
      subCategory: EventSubCategories.PAYMENT_METHODS,
      type: `REQUEST_PAYMENT_LIMITED_USE_TOKEN.REQUEST`,
      data: {
        mutationVariables,
      },
    });
  }
}

export { RequestPaymentLimitedUseTokenRequest };
